module.exports = __webpack_public_path__ + "static/img/logo.1d5dacba.png";